<div class="form-group">
    <label class="input-label">{{ 'Default Date' | translate }}</label>
    <input type="text"
           name="fieldOptions.label"
           placeholder="moment()"
           value="{{fieldOptions.defaultDate}}"
           [(ngModel)]="fieldOptions.defaultDate"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>